import { Box, Grid } from "@mui/material";
import { ThemeProvider } from "@mui/styles";
import React, { useState, useEffect, useRef } from "react";
import { GlobalTheme } from "../../themes/GlobalTheme";
import UserMenu from "../Account/UserMenu";
import LanguageSelector from "../Widgets/LanguageSelector";
import VersionJSON from "../../common/sharedSettings.json";
import NewUserView from "../Views/NewUserView";
import { useDispatch, useSelector } from "react-redux";
import { loadTranslations } from "../../js/redux/actions/i18n";
import translations from "../../l10n/translations";
import { t } from "react-i18nify";
import { OTAppBar } from "../Widgets/AppBar";

const version = VersionJSON.Version;
const NewUserLayout = () => {
    const locale = useSelector(state => state.i18n.locale);

    const appBarRef = useRef(null);

    const [language, setLanguage] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        setLanguage(locale);
    }, [locale]);

    useEffect(() => {
        if (locale) {
            dispatch(loadTranslations(translations));
        }
    }, [dispatch, locale]);

    return (
        <ThemeProvider theme={GlobalTheme}>
            <OTAppBar
                ref={appBarRef}
                UpperAppBar={
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            ml: { xs: 2 },
                        }}
                    >
                        <Box sx={{ typography: "body2", mr: 2 }}>
                            v. {version}
                        </Box>
                        <LanguageSelector />
                        <UserMenu username={null} />
                    </Box>
                }
                LowerAppBar={
                    <Box
                        sx={{
                            width: 1,
                            height: 60,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Grid item sx={{ flexGrow: 1 }} />
                        <Box sx={{ typography: "subtitleMajor", mr: 2 }}>
                            {t("view.newUser.Welcome")}
                        </Box>
                    </Box>
                }
            />
            {language ? <Grid
                container
                component="main"
                p={1}
                sx={{
                    display: "flex",
                    alignItems: "space-between",
                }}
            >
                <NewUserView />
            </Grid> : null}
        </ThemeProvider>
    );
};

export default NewUserLayout;
